// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".organism-tabs-technical-specs-v2[data-v-4a70fc30]{margin-top:1.25rem}@media only screen and (max-width:767px){.organism-tabs-technical-specs-v2[data-v-4a70fc30]{margin-top:15px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
